import { render, staticRenderFns } from "./CardAccordion.vue?vue&type=template&id=da209d26&scoped=true"
import script from "./CardAccordion.vue?vue&type=script&lang=js"
export * from "./CardAccordion.vue?vue&type=script&lang=js"
import style0 from "./CardAccordion.vue?vue&type=style&index=0&id=da209d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da209d26",
  null
  
)

export default component.exports